import { render, staticRenderFns } from "./AssessmentPeriodExport.vue?vue&type=template&id=28840ea9"
import script from "./assessment-period-export.ts?vue&type=script&lang=ts&external"
export * from "./assessment-period-export.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports